import styled from 'styled-components';

export const EmailAuthStyled = styled.div`

`